import { WarehouseForBooking } from 'entities/Warehouse';
import i18n from 'app/config/i18Config/i18n';
import { formatPrice } from 'shared/utils/helpers/formatPrice';

export const renderBalloonContent = (
  warehouse: WarehouseForBooking,
  finalPrice: number,
  currencySymbol: string,
  markerId: string,
): string => {
  const functionName = `selectWarehouseMarker_${markerId.replace(/[^a-zA-Z0-9]/g, '_')}`;
  const warehouseImage = warehouse.imageUrl || '';

  const boxesFreeText = i18n.t('{{availableBoxesAmount}} boxes free', {
    availableBoxesAmount: warehouse.availableBoxesAmount,
    ns: 'booking',
  });
  const fromPerMonthText = i18n.t('From {{discountedPrice}} {{currencySymbol}}/month', {
    discountedPrice: formatPrice(finalPrice),
    currencySymbol,
    ns: 'booking',
  });

  return `
    <div style="background: white; border-radius: 8px; overflow: hidden;">
      <div style="display: flex;">
        <div style="width: 100px; height: 100px; flex-shrink: 0; border-radius: 8px; margin-right: 10px; overflow: hidden;">
          <img
            style="width: 100%; height: 100%; object-fit: cover;"
            src="${warehouseImage}"
            alt="${warehouse.name} warehouse"
          />
        </div>

        <div style="flex: 1; padding: 5px; display: flex; flex-direction: column; justify-content: space-between;">
          <div>
            <h3 style="font-size: 16px; font-weight: 600; font-family: Tektur; color: var(--primary); margin: 0 0 4px 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              ${warehouse.name}
            </h3>
            <p style="font-size: 14px; color: var(--grey); margin: 0;">${boxesFreeText}</p>
          </div>

          <div style="margin-top: 8px;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              ${
                warehouse.minPrice
                  ? `
                <div style="font-size: 16px; font-weight: 600; font-family: Tektur; color: var(--primary);">
                  ${fromPerMonthText}
                </div>
              `
                  : '<div></div>'
              }
              <button
                onclick="window.${functionName}();"
                style="width: 36px; height: 36px; margin-left: 10px; border-radius: 6px; background: var(--primary); color: white; border: none; cursor: pointer; transition: background-color 0.2s; display: flex; align-items: center; justify-content: center;"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
};
